import { Reducer } from 'redux';
import { ErrorAction, ErrorActionType } from '../actions';

type ReducerState = Error | null;
type ReducerAction = ErrorAction;

const initialState: ReducerState = null;

export const error: Reducer<ReducerState> = (state: ReducerState = initialState, action: ReducerAction): ReducerState => {
    switch (action.type) {
        case ErrorActionType.NewError:
            return action.error;
        case ErrorActionType.ErrorCleared:
            return null;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/error.ts